import * as React from 'react';
import Axios, { AxiosResponse } from 'axios';
import { IMedia, ITag, IPagination } from '../interfaces';
import config from '../config';
import Pagination from '../components/common/Pagination';
import { withTranslation } from 'react-i18next';
import Banner from '../components/parts/Banner';
import Helmet from 'react-helmet';

const CancelToken = Axios.CancelToken;
let cancel: any;

interface IState {
    isLoading: boolean,
    wallpapers: IMedia[],
    tags: ITag[],
    tag_id: number,
    currentPage: number,
    totalPages: number,
    pages: IPagination,
}

class Wallpaper extends React.Component<any, IState>{
    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);

        this.state = {
            isLoading: true,
            wallpapers: [],
            tag_id: null,
            tags: [],
            currentPage: 1,
            totalPages: 1,
            pages: null,
        };

        this.onPageChange = this.onPageChange.bind(this);
    }

    componentDidMount() {
        this.loadWallpapers();
        this.loadTags();
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    async loadWallpapers() {
        cancel && cancel();
        
        this.setState({
            isLoading: true,
            wallpapers: [],
        }, async () => {
            try {
                let response: AxiosResponse = await Axios.get(`${config.host}/wallpaper/list` + (this.state.tag_id ? `?tag_id=${this.state.tag_id}` : "") + (this.state.pages ? ((this.state.tag_id ? `&` : `?`) + `${this.state.pages.pageParam}=${this.state.currentPage}`) : ``), {
                    cancelToken: new CancelToken(function executor(c) {
                        cancel = c;
                    })
                });

                let { data } = response;

                let totalPages = response.data.pages.pageCount;

                if (!this._isUnmounted) {
                    this.setState({
                        wallpapers: data.wallpapers,
                        isLoading: false,
                        pages: data.pages,
                        totalPages: totalPages,
                        currentPage: totalPages > 0 ? this.state.currentPage : 1
                    });
                }
            } catch (err) {

            }
        })
    }

    async loadTags() {
        let response: AxiosResponse = await Axios.get(`${config.host}/stat/wallpaper-tags`);

        if (!this._isUnmounted)
            this.setState({
                tags: response.data
            });
    }


    onPageChange(page: number) {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });

        this.setState({
            currentPage: page,
            isLoading: true,
        }, this.loadWallpapers);
    }


    onTagChange(tag_id: number) {
        this.setState({
            tag_id,
            isLoading: true,
        }, this.loadWallpapers);
    }

    render() {
        const {t} = this.props;
        
        return (
            <div className="i-body">
                <Helmet>
                    <title>{t("Обои") + " | " + window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>
                </Helmet>
                <div className="container login-page v-index">
                    <div className="wrapper">
                        <div className="fast_link">
                            <div className="title">{t("Быстрые ссылки")}</div>
                            <ul>
                                <li key={99999}>
                                    <a className={this.state.tag_id == null ? "fw-bold" : ""} onClick={() => {
                                        this.onTagChange(null);
                                    }}>{t("Все")}</a>
                                </li>
                                {this.state.tags.map((tag: ITag, index: number) => {
                                    return (<li key={index}>
                                        <a className={this.state.tag_id == tag.tag_id ? "fw-bold" : ""} onClick={() => {
                                            this.onTagChange(tag.tag_id);
                                        }}>{tag.name}</a>
                                    </li>);
                                })}
                            </ul>
                        </div>

                        {this.state.isLoading && <div className="carousel-placeholder"></div>}
                        {!this.state.isLoading && <div className="story_list">
                            <div className="row">
                                {this.state.wallpapers.map((wallpaper: IMedia, index: number) => {
                                    return (
                                        <div key={index} className="col-md-3 col-xs-6">
                                            <div className="pict_box">
                                                <div className="icons">
                                                    <a href={wallpaper.fullpath} data-lightbox="image-1" data-title={wallpaper.name} className="view" data-media_id={wallpaper.media_id}>
                                                        <i className="fa fa-search"></i>
                                                    </a>
                                                    <div className="view_stat">
                                                        <i className="fa fa-eye"></i>
                                                        {wallpaper.download}
                                                    </div>
                                                    <a href={`${config.site}/site/upload/${wallpaper.media_id}?type=download`} className="down">
                                                        <i className="fa fa-download"></i>
                                                    </a>
                                                </div>
                                                <img style={{ width: "100%", height: "100%" }} src={wallpaper.resized} alt={wallpaper.name} />
                                            </div>
                                        </div>
                                    );
                                })}

                            </div>
                            {this.state.wallpapers.length > 0 && <Pagination currentPage={this.state.currentPage} totalPages={this.state.totalPages} onChange={this.onPageChange} />}
                        </div>}
                        <Banner className="banner235" place={21} />

                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Wallpaper);